<template>
	<div class="element-document is-empty">
		<a :href="url(smartlink)" class="app--button primary d-block border--button" :class="[options('style'), classes()]" v-if="!options('smartlink') || smartlink">
			<app-icon value="download"></app-icon>
            <span v-html="macro(options('label'))"></span>
		</a>
	</div>
</template>

<script>
import store from '../../store'

export default {
	props: {
        definition: { type: Object, required: true }, 
		element:    { type: Object, required: true },
	},
	computed: {
        preview()   { return store.state.preview === true },
        printing()  { return store.state.printing },
        smartlink() { return this.options('smartlink') ? store.getters.smartlink(this.options('smartlink'), this.element, 'file') : ''},
    },
	methods: {
        classes()      { let p = store.state.theme.print.elements.input; return 'print--size-' + p.size + ' print--color-' + p.color },
		macro  (value) { return store.getters['macro'](value) },
        options(value) { return store.getters['options'](this.definition, value) },
		url    (url)   { 
            let result = url && url.length > 0 ? ((this.preview ? '/app/engagements/file/' : '/e/media/file/') + store.state.id + '/' + url) : this.options('file') 
            return result && result.length > 0 ? result : 'javascript:void(0);'
        },
	}
}
</script>
